export default {
	CONVERSION: {
		UPDATE:  'conversion/update'
	},
	UPDATE_USER: 'users/update'
}